import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { safeConfirm } from '../../lib/confirm';
import { Plus, Trash2, Briefcase, Power } from 'lucide-react';

export default function AdminServices() {
  const [items, setItems] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ name: '', description: '', duration_min: 45, price: 200, currency: 'PLN', active: true });

  const load = () => api.get('/services').then(r => setItems(r.data));
  useEffect(() => { load(); }, []);

  const submit = async () => {
    await api.post('/services', { ...form, duration_min: parseInt(form.duration_min), price: parseFloat(form.price) });
    setShow(false); setForm({ ...form, name: '', description: '' });
    load();
  };
  const toggle = async (svc) => {
    await api.put(`/services/${svc.service_id}`, { ...svc, active: !svc.active });
    load();
  };
  const remove = async (id) => {
    if (!(await safeConfirm('Delete this service?'))) return;
    await api.delete(`/services/${id}`);
    load();
  };

  return (
    <div className="p-4 md:p-8 max-w-6xl">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-accent font-medium mb-2">MENU</div>
          <h1 className="text-3xl md:text-4xl font-heading font-bold tracking-tight">Services</h1>
          <p className="text-fg-muted mt-2 text-sm">Services you offer — name, session time and price. Used when scheduling appointments.</p>
        </div>
        <button onClick={()=>setShow(!show)} className="btn-primary inline-flex items-center gap-2" data-testid="new-service-btn">
          <Plus className="w-4 h-4"/> New service
        </button>
      </div>

      {show && (
        <div className="admin-card mb-6">
          <h3 className="font-heading font-semibold mb-3">New service</h3>
          <div className="grid md:grid-cols-3 gap-3">
            <Field label="Name"><input className="input" value={form.name} onChange={e=>setForm({...form, name:e.target.value})} data-testid="svc-name"/></Field>
            <Field label="Duration (min)"><input type="number" className="input" value={form.duration_min} onChange={e=>setForm({...form, duration_min:e.target.value})} data-testid="svc-duration"/></Field>
            <Field label="Price"><input type="number" step="0.01" className="input" value={form.price} onChange={e=>setForm({...form, price:e.target.value})} data-testid="svc-price"/></Field>
            <Field label="Currency">
              <select className="input" value={form.currency} onChange={e=>setForm({...form, currency: e.target.value})}>
                <option>PLN</option><option>EUR</option><option>USD</option><option>CAD</option><option>XCD</option>
              </select>
            </Field>
            <Field label="Description" full>
              <textarea className="input" value={form.description} onChange={e=>setForm({...form, description: e.target.value})}/>
            </Field>
          </div>
          <div className="mt-3 flex justify-end">
            <button onClick={submit} className="btn-primary" disabled={!form.name} data-testid="svc-save">Save</button>
          </div>
        </div>
      )}

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(s => (
          <div key={s.service_id} className="bento-card" data-testid={`service-${s.service_id}`}>
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-2">
                <Briefcase className="w-4 h-4 text-brand"/>
                <h3 className="font-heading font-semibold">{s.name}</h3>
              </div>
              {s.active ? <span className="badge-success">Active</span> : <span className="badge-neutral">Off</span>}
            </div>
            <p className="text-sm text-fg-secondary mt-2">{s.description}</p>
            <div className="mt-3 flex items-center justify-between border-t border-soft pt-3">
              <div>
                <div className="text-2xl font-heading font-bold">{s.price.toFixed(2)} <span className="text-xs text-fg-muted">{s.currency}</span></div>
                <div className="text-xs text-fg-muted">{s.duration_min} min session</div>
              </div>
              <div className="flex gap-2">
                <button onClick={()=>toggle(s)} className="text-brand p-1" title="Toggle active" data-testid={`svc-toggle-${s.service_id}`}><Power className="w-4 h-4"/></button>
                <button onClick={()=>remove(s.service_id)} className="text-[#B83A3A] p-1" data-testid={`svc-del-${s.service_id}`}><Trash2 className="w-4 h-4"/></button>
              </div>
            </div>
          </div>
        ))}
        {!items.length && <div className="text-fg-muted text-sm">No services yet.</div>}
      </div>
    </div>
  );
}

function Field({ label, full, children }) {
  return (
    <label className={full ? 'md:col-span-3 block' : 'block'}>
      <div className="text-xs text-fg-muted mb-1">{label}</div>
      {children}
    </label>
  );
}
